module.exports = __webpack_public_path__ + "img/coverage.2a59b1e8.svg";